import { HttpService } from '../../../App/services/http'

export const SynonymService = {
    units,
    unit,
    values,
    remove,
    save,
    filter
}

function units (params) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/dictionary/synonym/units`, options, true)
        .then(response => {
            return response
        })
}

function unit (id) {
    const options = {
        method: 'GET'
    }

    return HttpService.http(`/dictionary/synonym/unit/${id}`, options, true)
        .then(response => {
            return response.unit
        })
}

function values (id, params) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/dictionary/synonym/unit/${id}/values`, options, true)
        .then(response => {
            return response
        })
}

function remove (id, params) {
    const options = {
        method: 'DELETE',
        body: JSON.stringify(params)
    }

    return HttpService.http(`/dictionary/synonym/unit/${id}/values`, options, true)
        .then(response => {
            return response
        })
}

function save (id, params) {
    const options = {
        method: 'PUT',
        body: JSON.stringify(params)
    }

    return HttpService.http(`/dictionary/synonym/unit/${id}/values`, options, true)
        .then(response => {
            return response
        })
}

function filter (id = null, params = {}) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(id ? `/dictionary/synonym/unit/${id}/values/filter` : `/dictionary/synonym/units/filter`, options, true)
        .then(response => {
            return response
        })
}

